import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps, webpageProps } from 'js/analytics/standardizedProps'

export const trackAppStoreButtonClick = ({ type }) => {
  ga.track('app_store_buttons_click', {
    type,
  })
  amplitude.track('user_interact_object', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'click',
    action_type: 'active',
    object_name: `${type}_lifesum_app_download_button`,
  })
}
